import { Component, h, Prop } from '@stencil/core';
import { PageNodeCTA } from 'interfaces/PageNode';

@Component({
  tag: 'kdx-mega-nav-cta',
  shadow: false,
})
export class KdxMegaNavCta {

  @Prop() CTA: PageNodeCTA;

  render() {
    return (
      <div class="app-nav__cta">
        <div class="app-nav__cta-content">
          {this.CTA.ImgUrl && (
            <img src={this.CTA.ImgUrl} alt={this.CTA.Title} />
          )}
          <div class="cta-title">{this.CTA.Title}</div>
          {Boolean(this.CTA.Description) && <div class="cta-description" innerHTML={this.CTA.Description}></div>}
          <a
            href={this.CTA.LinkUrl}
            aria-label={this.CTA.LinkTitle}
            class={'cta-link ' + (this.CTA.LinkSpeedbump ? 'speedbump-link' : '')}
            target={this.CTA.LinkNewTab ? '_blank' : null}>
            {this.CTA.LinkTitle} 
            <kdx-icon icon="chevron-right"></kdx-icon>
          </a>
        </div>
      </div>
    );
  }

}